/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Meta_TitleInputs */

const en_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Play Injury Free | Mark Egly Golf`)
};

const es_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juega sin lesiones | Mark Egly Golf`)
};

const de_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verletzungsfrei spielen | Mark Egly Golf`)
};

const zh_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打球不伤身 | Mark Egly Golf`)
};

const ar_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العب بلا إصابات | Mark Egly Golf`)
};

const fr_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouer sans blessure | Mark Egly Golf`)
};

const vi_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chơi không chấn thương | Mark Egly Golf`)
};

const sw_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheza Bila Majeraha | Mark Egly Golf`)
};

const th_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เล่นกอล์ฟโดยไม่บาดเจ็บ | Mark Egly Golf`)
};

const bs_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Igraj bez povreda | Mark Egly Golf`)
};

const ja_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケガなくプレーする | Mark Egly Golf`)
};

const ko_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`부상 없이 플레이 | Mark Egly Golf`)
};

const pt_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogue sem lesões | Mark Egly Golf`)
};

const it_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gioca senza infortuni | Mark Egly Golf`)
};

const sv_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spela skadefritt | Mark Egly Golf`)
};

const nl_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blessurevrij spelen | Mark Egly Golf`)
};

const da_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spil skadefrit | Mark Egly Golf`)
};

const nb_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spill uten skader | Mark Egly Golf`)
};

const fi_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelaa ilman vammoja | Mark Egly Golf`)
};

const pl_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Graj bez kontuzji | Mark Egly Golf`)
};

const ru_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Играйте без травм | Mark Egly Golf`)
};

const tr_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sakatlanmadan oynayın | Mark Egly Golf`)
};

const hi_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चोट-मुक्त खेलें | Mark Egly Golf`)
};

const id_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain Tanpa Cedera | Mark Egly Golf`)
};

const ms_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bermain tanpa kecederaan | Mark Egly Golf`)
};

const cs_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hrajte bez zranění | Mark Egly Golf`)
};

const el_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Παίξτε χωρίς τραυματισμούς | Mark Egly Golf`)
};

const he_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שחקו ללא פציעות | Mark Egly Golf`)
};

const af_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speel sonder beserings | Mark Egly Golf`)
};

const hu_injury_meta_title = /** @type {(inputs: Injury_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Játssz sérülésmentesen | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Play Injury Free \| Mark Egly Golf" |
*
* @param {Injury_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_meta_title = /** @type {((inputs?: Injury_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_meta_title(inputs)
	if (locale === "de") return de_injury_meta_title(inputs)
	if (locale === "zh") return zh_injury_meta_title(inputs)
	if (locale === "ar") return ar_injury_meta_title(inputs)
	if (locale === "fr") return fr_injury_meta_title(inputs)
	if (locale === "vi") return vi_injury_meta_title(inputs)
	if (locale === "sw") return sw_injury_meta_title(inputs)
	if (locale === "th") return th_injury_meta_title(inputs)
	if (locale === "bs") return bs_injury_meta_title(inputs)
	if (locale === "ja") return ja_injury_meta_title(inputs)
	if (locale === "ko") return ko_injury_meta_title(inputs)
	if (locale === "pt") return pt_injury_meta_title(inputs)
	if (locale === "it") return it_injury_meta_title(inputs)
	if (locale === "sv") return sv_injury_meta_title(inputs)
	if (locale === "nl") return nl_injury_meta_title(inputs)
	if (locale === "da") return da_injury_meta_title(inputs)
	if (locale === "nb") return nb_injury_meta_title(inputs)
	if (locale === "fi") return fi_injury_meta_title(inputs)
	if (locale === "pl") return pl_injury_meta_title(inputs)
	if (locale === "ru") return ru_injury_meta_title(inputs)
	if (locale === "tr") return tr_injury_meta_title(inputs)
	if (locale === "hi") return hi_injury_meta_title(inputs)
	if (locale === "id") return id_injury_meta_title(inputs)
	if (locale === "ms") return ms_injury_meta_title(inputs)
	if (locale === "cs") return cs_injury_meta_title(inputs)
	if (locale === "el") return el_injury_meta_title(inputs)
	if (locale === "he") return he_injury_meta_title(inputs)
	if (locale === "af") return af_injury_meta_title(inputs)
	if (locale === "hu") return hu_injury_meta_title(inputs)
	return en_injury_meta_title(inputs)
});